export const Paw: string = "paw";
export const AdminTool: string = "admin-tool";

export default {
    Paw: Paw,
    AdminTool: AdminTool
};